
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class LogoOverlay extends Vue {
  @Prop() public src: any;
  @Prop({ default: true }) public visible!: boolean;
}
